<template>
    <div class="row" style="margin-top: 3px;" :id="this.oid">

        <!-- Option Properties -->
        <div class="col-md-2 quiz-left-column option-row"
             v-bind:class="{'text-success': isCorrect, 'text-danger': !isCorrect}">
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][oid]'" :value="oid"/>

            <i class="fa" v-bind:class="{'fa-check': isCorrect, 'fa-times': !isCorrect}"></i>
            <input type="hidden" :name="'questions['+questionIdx+'][options]['+idx+'][isCorrect]'" :value="isCorrect"/>
            {{isCorrect ? 'Correct' : 'Incorrect'}}<br/>
            <span style="font-weight: bold; color: #444" v-if="isSuggestedAnswer">Suggested Answer</span>
        </div>

        <!-- Option Text -->
        <div class="quiz-text-column option-row"
             :class="[
            approved ? 'quiz-text-column-success' : '',
            rejected ? 'quiz-text-column-danger' : '',
            otherLanguages !== null ? 'col-md-3' : 'col-md-5'
            ]">
            <span dir="auto">{{XX_en}}</span>
        </div>

        <template v-if="otherOptions">
            <div
                v-for="(lang, otherLocale) in otherLanguages"
                class="col-md-3 quiz-text-column option-row hideable-by-language"
                :class="[
                    approved ? 'quiz-text-column-success' : '',
                    rejected ? 'quiz-text-column-danger' : '',
                    otherLocale,
                ]"
            >
                <span dir="auto">{{otherOptions.text[otherLocale]}}</span>
            </div>
        </template>

        <div class="quiz-text-column option-row"
             :class="[
                  approved ? 'quiz-text-column-success' : '',
                  rejected ? 'quiz-text-column-danger' : '',
                  otherLanguages !== null ? 'col-md-4' : 'col-md-5'
             ]"
        >
            <input type="hidden"
                   :name="'questions['+questionIdx+'][options]['+idx+'][text]['+locale+']'"
                   :value="translation"
            />
            <table>
                <tr>
                    <td>
                        <i
                            style="margin-left: 5px;"
                            class="fa fa-eye tool_tip"
                            :title="itranslation"
                            data-toggle="tooltip"
                        >
                        </i>
                    </td>
                    <td style="padding-left: 5px;">
                        <input type="text"
                             :disabled="disabled"
                             title="translation"
                             dir="auto"
                             v-model="translation"
                             onfocus="preview(this.value);"
                             onkeyup="preview(this.value);"
                        />
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            'isCorrect': Boolean,
            'locale': String,
            'XX_en': String,
            'otherOptions': Object,
            'otherLanguages': Object,
            'disabled': Boolean,
            'idx': Number,
            'questionIdx': Number,
            'oid': String,
            'approved': Boolean,
            'rejected': Boolean,
            'itranslation': String,
            'isSuggestedAnswer': Boolean,
        },

        data: function() {
            return {
                translation: this.itranslation,
            };
        },
    };
</script>
